(function () {
    'use strict';

    angular.module('customeDirectivesModule')
        .directive('ngLoadDirective', loadDirective)
        .directive('inLoadingStateWhenClick', buttonDirective);

    loadDirective.$inject = ['$http'];
    function loadDirective($http) {
        return {
            restrict: 'A',
            template: '<div class="spinner-icon"></div>',
            link: function (scope, elm, attrs) {
                scope.isLoading = function () {
                    return isShowLoading($http.pendingRequests);
                };

                scope.$watch(scope.isLoading, function (v) {
                    if (v) {
                        elm.show();
                    } else {
                        elm.hide();
                    }
                });

                function isShowLoading(pendingRequests) {
                    return pendingRequests.some(function (r) {
                        return (r.params && r.params.showLoading);
                    });
                }
            }
        };
    }

    buttonDirective.$inject = ['$parse', '$q', '$timeout'];
    function buttonDirective($parse, $q, $timeout) {
        return {
            restrict: 'A',
            priority: 0,
            link: function (scope, element, attrs) {
                var action = $parse(attrs.inLoadingStateWhenClick);

                element.on('click', function (e) {
                    element.attr('disabled', 'disabled');

                    $timeout(function () {
                        var promise = action(scope, { $event: e }),
                            isPromise = promise && promise.finally;

                        if (isPromise) {
                            promise
                                .then(function (promise) {
                                    if (promise && promise.message) {
                                        return $q.reject(promise.message);
                                    }
                                })
                                .catch(function (exception) {
                                    if (exception) {
                                        console.log(exception);
                                    }
                                })
                                .finally(function () {
                                    releaseClick();
                                });
                        } else {
                            releaseClick();
                        }
                    });
                });

                function releaseClick() {
                    element.removeAttr('disabled');
                    element.find('.processing').remove();
                }
            }
        };
    }
})();